import { Component, HostListener, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Cliente } from '../cadastro/cliente';
import { ClienteService } from "../cadastro/service/cliente.service";
import { EnumSolicitacaoCompraFornecedorStatus } from '../enum-types/enum-solicitacao-compra-fornecedor-status';
import { EnumSolicitacaoCompraTipoFrete } from '../enum-types/enum-solicitacao-compra-tipo-frete';
import { JwtService } from '../jwt.service';
import { CotacaoManager } from '../managers/cotacao-manager';
import { SolicitacaoCompraItemCotacao } from '../managers/solicitacao-compra-item-cotacao';
import { OrderList } from '../order-list/order-list';
import { SolicitacaoCompraFornecedor } from '../persistences/solicitacao-compra-fornecedor';
import { Configuracoes } from '../services/configuracoes.service';
import { CotacaoService } from '../services/cotacao.service';
import { NumberUtils } from '../utils/number-utils';
import { CORE_IMPORTS } from '../providers/module-providers';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
  standalone: true,
  selector: 'app-cotacao-todos-itens',
  templateUrl: './cotacao-todos-itens.component.html',
  styleUrls: ['./cotacao-todos-itens.component.css', "../cotacao/cotacao.css",  "../item-cotacao/item-cotacao.css", "../app.component.css" ],
  imports: [CORE_IMPORTS,NgxPaginationModule]
})
export class CotacaoTodosItensComponent implements OnInit {
    public cotacoes: { [id: string] : CotacaoManager; } = {};
    public todosItens: { [id: string] : Array<[SolicitacaoCompraItemCotacao, CotacaoManager, number]>; } = {};
    tiposDeFrete = Object.keys(EnumSolicitacaoCompraTipoFrete).filter(key => !isNaN(Number(EnumSolicitacaoCompraTipoFrete[key])));
    public abaAtual = 0;
    public allExpandState = true;
    public ol: OrderList;
    public showOl = false;
    public innerWidth = 1500;
    public page = 1;
    clienteLogado: Cliente;
    constructor (
      private cotacaoService: CotacaoService,
      private clienteService: ClienteService,
      private router: Router,
      private snackBar: MatSnackBar,
      public configuracoes: Configuracoes,
      public jwtService: JwtService
    ) {}
  
    ngOnInit () {
      this.load();
      this.ol = new OrderList(["Descrição", "Cod. Fabricante", "Marca"]);
    }
  
    @HostListener('window:resize', ['$event'])
    onResize(event) {
      this.innerWidth = window.innerWidth;
    }
  
    load () {
      this.cotacaoService.getSolicitacoesCompletas()
        .subscribe((val: SolicitacaoCompraFornecedor[]) => {
          for (const sol of val) {
            const cotObj = 
              new CotacaoManager(
                this.clienteLogado,
                this.cotacaoService,
                this.clienteService,
                this.router,
                this.snackBar,
                this.configuracoes,
                this.jwtService
              );
            cotObj.setCdFilial(sol.solicitacaoCompra.cdFilial);
            cotObj.setNrSolicitacao(sol.solicitacaoCompra.nrSolicitacao);
            cotObj.onLoadCotacao(sol);
  
            //#TODO constantes
            cotObj.configuracoes.getConfigNumber()
              .subscribe(casasDecimais => {
                cotObj.numberMaskConfig = NumberUtils.getMaskConfig(0, Number.MAX_VALUE, parseInt(casasDecimais));
                cotObj.onLoad();
              }, cotObj.onError);
  
            this.cotacoes[cotObj.nrSolicitacao] = cotObj;
          }
          this.fillDict();
        }, (e:Response) => console.log(e.text()));
    }
  
  
    fillDict () {
      for (const key in this.cotacoes) {
        const cot = this.cotacoes[key];				
        for (const prod of cot.cotacao.solicitacaoCompraItemCotacoes) {
          if (prod.solicitacaoCompraItem.item.cdItem in this.todosItens) {
            this.todosItens[prod.solicitacaoCompraItem.item.cdItem].push([prod, cot, 0]);
          }
          else {
            this.todosItens[prod.solicitacaoCompraItem.item.cdItem] = [[prod, cot, 0]];
          }
        }
      }
    }
  
  
    getCodCotacoesItemDict (id: string): string {
      let cods = "";
      for (const prod of this.todosItens[id]) {
        cods += prod[1] + " ";
      }
      return cods;
    }
  
  
    getTodosItensArray (): Array<[SolicitacaoCompraItemCotacao, CotacaoManager, number]> {
      const a: Array<[SolicitacaoCompraItemCotacao, CotacaoManager, number]> = [];
  
      for (const i in this.todosItens) {
        this.recalculaItens(this.todosItens[i]);
        a.push(this.todosItens[i][0]);
      }
      // Ordenar antes de retornar (isso vai dar ruim)
      this.ordenaItens(a,
              (this.ol.listaEscolhido[0] == undefined ? "" : this.ol.listaEscolhido[0]),
              (this.ol.listaEscolhido[1] == undefined ? "" : this.ol.listaEscolhido[1]),
              (this.ol.listaEscolhido[2] == undefined ? "" : this.ol.listaEscolhido[2]));
      return a;
    }
  
    salvarItens(itemAgrupado: [SolicitacaoCompraItemCotacao, CotacaoManager, number]) {
      for (const item of this.todosItens[itemAgrupado[0].solicitacaoCompraItem.item.cdItem]) {
        item[1].salvarItem(item[0]);
      }
    }
  
  
    // Retorna a conversão do dict de Cotações para Array.
    getTodasCotacoesArray (): Array<CotacaoManager> {
      const cotacoesArray: Array<CotacaoManager> = [];
      for (const key in this.cotacoes) {
        cotacoesArray.push(this.cotacoes[key]);
        //this.cotacoes[key].cotacao.vlTotal.toFixed(2)
      }
      return cotacoesArray;
    }
  
  
    areAllLoadSuccess (): boolean {
      //console.log("areAllLoadSuccess");
      for (const key in this.cotacoes) {
        if (!this.cotacoes[key].loadSuccess) {
          return false;
        }
      }
      return true;
    }
  
  
    qtdeTotal (idItem: string): number {
      let qt = 0;
      for (const i of this.todosItens[idItem]) {
        qt += i[0].solicitacaoCompraItem.qtSolicitada;
      }
      return qt;
    }
    sendAll () {
      for (const key in this.cotacoes) {
        if(this.cotacoes[key].send2() == false) {
          this.cotacoes[key].mostrarNotificacao("Data de validade inválida na cotação " + this.cotacoes[key].nrSolicitacao);
          return;
        }
      }
      for (const key in this.cotacoes) {
        this.cotacoes[key].mostrarNotificacao("Salvo");
        return;
      }
    }
  
    finalizaTodas () {
      for (const key in this.cotacoes) {
        this.cotacoes[key].cotacao.flStatus = EnumSolicitacaoCompraFornecedorStatus[EnumSolicitacaoCompraFornecedorStatus.FECHADO[0]];
      this.sendAll();
      }
    }
  
    // terminar essa bagaça
    copiaItem (orig: SolicitacaoCompraItemCotacao, dest: SolicitacaoCompraItemCotacao) {
      dest.vlBruto = orig.vlBruto;
      dest.pcDesconto = orig.pcDesconto;
      dest.ipiPcAliq = orig.ipiPcAliq;
      dest.icmsPcAliquota = orig.icmsPcAliquota;
      dest.icmsValor = orig.icmsValor;
      dest.icmsStPcAliquota = orig.icmsStPcAliquota;
      dest.icmsStValor = orig.icmsStValor;
      dest.vlTotal = orig.vlTotal;
      dest.qtCotacao = orig.qtCotacao;
      dest.obs = orig.obs;
      dest.vlFrete = orig.vlFrete;
    }
  
  
    scroll(id: string) {
      document.getElementById(id).scrollIntoView();
    }
  
    recalculaItens (itens: Array<[SolicitacaoCompraItemCotacao, CotacaoManager, number]>, calculaAliq = false,
      recalcVlTotal = true) {
        let qt = 0;
        let total = 0;
  
        // Recalcula o índice 0
        itens[0][1].recalculaItem(itens[0][0], calculaAliq, recalcVlTotal);
  
        // Copia o item 0 para os demais
        for (const item of itens) {
          // Salva a quantidade de itens
          qt = item[0].qtCotacao;
  
          this.copiaItem(itens[0][0], item[0]);
          item[0].qtCotacao = qt;
  
          item[1].recalculaItem(item[0], calculaAliq, recalcVlTotal);
          if (item[0].vlTotal != undefined) {
            total += item[0].vlTotal;
          }
        }
  
        // Somar os valores totais e atualizar o indice 2 do item[0]
        itens[0][2] = total;
    }
  
  
    setDivVisible() {
      let $;
  
      $("div.search-nav").css("width", "100%");
      $("div.search-nav").css("left", "0");
    }
  
    get olStyle() {
      return {
        'visibility': this.showOl ? 'visible' : 'hidden',
        'opacity': this.showOl ? '1' : '0'
      };
    }
  
    get appContentStyle() {
      return {
        'opacity': this.showOl ? '0.5' : '1'
      };
    }
  
  
    // Recebe um SolicitacaoCompraItemCotacao e retorna o código do item
    getItemId (cot: SolicitacaoCompraItemCotacao): string {
      return cot.solicitacaoCompraItem.item.cdItem;
    }
  
  
    mostrarTresCampos(): boolean {
      return this.innerWidth > 1150;
    }
  
  
    mostrarUmCampo(): boolean {
      return this.innerWidth > 630;
    }
  
  
    ordenaItens(array: Array<[SolicitacaoCompraItemCotacao, CotacaoManager, number]>, A: string, B: string, C: string) {
      array.sort(function (a, b) {
  
        // Primeiro pega os atributos na ordem recebida
        const dictA: { [id: string]: string } = {};
        const dictB: { [id: string]: string } = {};
        //"Descrição", "Cod. Fabricante", "Marca"
        // Usar dict para garantir a ordem
        dictA["Cod. Fabricante"] = a[0].solicitacaoCompraItem.item.itemProduto.cdFabricante;
        dictA["Descrição"] = a[0].solicitacaoCompraItem.item.nmItem;
        dictA["Marca"] = a[0].solicitacaoCompraItem.item.itemProduto.marca.nmMarca;
  
        dictB["Cod. Fabricante"] = b[0].solicitacaoCompraItem.item.itemProduto.cdFabricante;
        dictB["Descrição"] = b[0].solicitacaoCompraItem.item.nmItem;
        dictB["Marca"] = b[0].solicitacaoCompraItem.item.itemProduto.marca.nmMarca;
  
        // Coloca os valores em variaveis locais
        const a1 = dictA[A];
        const a2 = dictA[B];
        const a3 = dictA[C];
  
        const b1 = dictB[A];
        const b2 = dictB[B];
        const b3 = dictB[C];
  
        // Ordenar
        if (a1 == b1) {
          if (a2 == b2) {
            if (a3 > b3) {
              return 1;
            }
            else if (a3 == b3) {
              return 0;
            }
            return -1;
          }
          else {
            if (a2 > b2) {
              return 1;
            }
            return -1;
          }
        }
        else {
          if (a1 > b1) {
            return 1;
          }
          return -1;
        }
      });
    }

    private dataDigitada = '';
    formatarDataValidade(input: string){
      //this.solicitacao.cotacao.dtValidade = this.formatarDataComBarras(input);
    }
  
    formatarDataFaturamento(input: string){
      //this.solicitacao.cotacao.dtFaturamento = this.formatarDataComBarras(input);
    }
  
    formatarDataComBarras(input: string): string {
      const maxLength = 10;
      const formattedInput = input
        .replace(/\D/g, '')
        .slice(0, maxLength);
  
      if (formattedInput.length >= 2) {
        this.dataDigitada =
          formattedInput.slice(0, 2) +
          (formattedInput.length >= 4
            ? '/' + formattedInput.slice(2, 4)
            : '') +
          (formattedInput.length >= 8 ? '/' + formattedInput.slice(4, 8) : '');
        return this.dataDigitada;
    } 
    }

    logout() {
      this.jwtService.logout();
    }    
  }